/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    Overlays: 50,
    Header: 100,
    Modal: 1000,
};
